import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { clearEnabledFeature, getEnabledFeature, setEnabledFeature } from '@ibk/shared-config';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Button, Input } from '@ibk/shared-ui';
import { sharedLayoutTranslations } from '../../translations';
import styles from './DeveloperSettings.module.css';
const DIGITS_ONLY_REGEX = /^\d*$/;
const isValidFeatureValue = (value) => {
    const trimmed = value.trim();
    if (!trimmed) {
        return false;
    }
    return DIGITS_ONLY_REGEX.test(trimmed);
};
export const DeveloperSettingsBase = () => {
    const { t } = useTranslation();
    const [value, setValue] = useState(() => getEnabledFeature() ?? '');
    const [feedback, setFeedback] = useState(null);
    const handleChange = (event) => {
        const nextValue = event.target.value;
        if (!DIGITS_ONLY_REGEX.test(nextValue)) {
            return;
        }
        setValue(nextValue);
        setFeedback(null);
    };
    const handleApply = () => {
        if (!isValidFeatureValue(value)) {
            setFeedback({ type: 'error', messageKey: 'developer-settings.invalid' });
            return;
        }
        setEnabledFeature(value.trim());
        setFeedback({ type: 'success', messageKey: 'developer-settings.applied-success' });
    };
    const handleClear = () => {
        clearEnabledFeature();
        setValue('');
        setFeedback({ type: 'success', messageKey: 'developer-settings.cleared-success' });
    };
    const applyDisabled = !isValidFeatureValue(value);
    return (_jsxs("section", { className: styles.container, "data-testid": 'developer-settings-page', children: [_jsxs("header", { className: styles.header, children: [_jsx("h1", { className: styles.title, "data-testid": 'developer-settings-title', children: t('developer-settings.title') }), _jsx("p", { className: styles.description, "data-testid": 'developer-settings-description', children: t('developer-settings.description') })] }), _jsxs("div", { className: styles.form, children: [_jsx(Input, { dataTestId: 'developer-settings-feature-input', size: 'large', label: t('developer-settings.input-label'), placeholder: t('developer-settings.input-placeholder'), value: value, onChange: handleChange, inputMode: 'numeric', autoComplete: 'off', id: 'developer-settings-feature-input' }), feedback &&
                        (feedback.type === 'error' ? (_jsx("p", { className: [styles.feedback, styles.feedbackError].join(' '), "data-testid": 'developer-settings-feedback-error', role: 'alert', children: t(feedback.messageKey) })) : (_jsx("output", { className: [styles.feedback, styles.feedbackSuccess].join(' '), "data-testid": 'developer-settings-feedback-success', htmlFor: 'developer-settings-feature-input', children: t(feedback.messageKey) }))), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { dataTestId: 'developer-settings-apply-button', variant: 'primary', size: 'medium', onClick: handleApply, disabled: applyDisabled, children: t('developer-settings.apply') }), _jsx(Button, { dataTestId: 'developer-settings-clear-button', variant: 'secondary', size: 'medium', onClick: handleClear, children: t('developer-settings.clear') })] })] })] }));
};
export const DeveloperSettings = () => {
    return (_jsx(TranslationProvider, { translations: sharedLayoutTranslations, defaultLanguage: 'pt-BR', children: _jsx(DeveloperSettingsBase, {}) }));
};
export default DeveloperSettings;
